import { FC, FormEvent, ReactElement, useState } from 'react'

import { FormActionButtons, Textarea } from '../../../compositions'
import trans from '../../../helpers/trans'

import './DeleteShiftPlanningForm.scss'

interface DeleteShiftPlanningFormProps {
    isLoading: boolean;
    showDeleteWithin24hWarning: boolean;
    isPlanned: boolean;
    fullName: string;
    onCancel: () => void;
    onSubmit: (comment?: string) => void;
    className?: string;
}

const DeleteShiftPlanningForm: FC<DeleteShiftPlanningFormProps> = ({
    isLoading,
    showDeleteWithin24hWarning,
    isPlanned,
    fullName,
    onCancel,
    onSubmit,
    className = '',
}): ReactElement => {
    const [comment, setComment] = useState<string>('')

    const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
        e.preventDefault()

        onSubmit(! isPlanned ? comment : undefined)
    }

    return (
        <form onSubmit={handleSubmit} className={`delete-shift-planning-form ${className}`}>
            <div className="delete-shift-planning-form__row">
                {showDeleteWithin24hWarning && (
                    <p className="delete-shift-planning-form__intro">
                        <strong>{`${trans('containers.forms.deleteShiftPlanningForm.attention')}: `}</strong>

                        {trans('containers.forms.deleteShiftPlanningForm.24hWarning', { fullName })}
                    </p>
                )}

                <p className="delete-shift-planning-form__intro">
                    {trans('containers.forms.deleteShiftPlanningForm.intro', {
                        fullName,
                        type: (isPlanned ? trans('common.shift') : trans('common.signup')).toLocaleLowerCase(),
                    })}
                </p>
            </div>

            {! isPlanned && (
                <div className="delete-shift-planning-form__row">
                    <Textarea
                        label={`${trans('common.comment')} (${trans('common.optional')}, ${trans('common.visibleToEmployee')})`}
                        rows={4}
                        value={comment}
                        onChange={setComment}
                        className="delete-shift-planning-form__col"
                    />
                </div>
            )}

            <FormActionButtons
                isLoading={isLoading}
                submitText={trans('common.delete')}
                onCancelClick={onCancel}
            />
        </form>
    )
}

export default DeleteShiftPlanningForm
